var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthPixel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 23,
    viewBox: "0 0 15 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1064_6898)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.18721 0H6.22905V0.958165H5.74996V1.91632H4.7918V3.83266H3.83364V4.79082H2.87548V6.70715H1.9173V7.66531H0.959141V9.58165H0.000976562V10.5398H0.959141V11.498H2.87548V12.4561H4.7918V13.4143H6.22905V14.3725H7.18721V13.4143H8.62446V12.4561H10.5408V11.498H12.4571V10.5398H13.4153V9.58165H12.4571V7.66531H11.4989V6.70715H10.5408V4.79082H9.58262V3.83266H8.62446V1.91632H7.66629V0.958165H7.18721V0ZM4.7918 12.4561V11.498H2.87548V10.5398H0.959141V9.58165H1.9173V7.66531H2.87548V6.70715H3.83364V4.79082H4.7918V3.83266H5.74996V1.91632H6.22905V12.4561H4.7918Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000976562 13.4154H0.959141V15.3317H1.9173V17.2481H2.87548V18.2063H3.83364V20.124H4.7918V21.0822H5.74996V22.0422H6.22905V23.0004H7.18721V22.0422H6.70812V22.0403H7.66629V21.0822H8.62446V20.124H9.58262V18.2063H10.5408V17.2481H11.4989V15.3317H12.4571V13.4154H13.4153V12.4573H12.4571V13.4154H10.5408V14.3736H8.62446V15.3308L7.18721 15.3317V16.2899H6.22905V15.3317H4.7918V14.3736H2.87548V13.4154H0.959141V12.4573H0.000976562V13.4154ZM2.87548 15.3317H1.9173V14.3736H2.87548V15.3317ZM2.87548 15.3317V17.2481H3.83364V18.2063H4.7918V20.124H5.74996V21.0794H6.70812V21.0822H7.66629V21.0794H6.70812V17.2481H6.22905V16.2899H4.7918V15.3317H2.87548Z",
    fill: "#929292"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1064_6898"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.3745,
    height: 22.9992,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthPixel);
export default __webpack_public_path__ + "static/media/ethPixel.54732c7049b41df2e2b51ae0f820ff68.svg";
export { ForwardRef as ReactComponent };